import { useState, useEffect } from 'react';
import content from '../content.json';
const pub = process.env.PUBLIC_URL;

function Gallery({ exp, onClose }) {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const fn = e => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') setIdx(i => (i + 1) % exp.images.length);
      if (e.key === 'ArrowLeft') setIdx(i => (i - 1 + exp.images.length) % exp.images.length);
    };
    window.addEventListener('keydown', fn);
    document.body.style.overflow = 'hidden';
    return () => { window.removeEventListener('keydown', fn); document.body.style.overflow = ''; };
  }, [exp.images.length, onClose]);

  return (
    <div onClick={onClose} style={{ position:'fixed',inset:0,zIndex:9999,background:'rgba(0,0,0,0.95)',display:'flex',alignItems:'center',justifyContent:'center' }}>
      <div onClick={e => e.stopPropagation()} style={{ position:'relative',maxWidth:'860px',width:'90vw' }}>
        <img src={`${pub}/${exp.images[idx]}`} alt={exp.title} style={{ width:'100%',maxHeight:'80vh',objectFit:'contain',display:'block' }} />
        {exp.images.length > 1 && (
          <>
            <button onClick={() => setIdx((idx-1+exp.images.length)%exp.images.length)} style={{ position:'absolute',left:'-56px',top:'50%',transform:'translateY(-50%)',background:'none',border:'none',cursor:'pointer',color:'white',fontSize:'36px',opacity:0.6 }} onMouseEnter={e=>e.currentTarget.style.opacity=1} onMouseLeave={e=>e.currentTarget.style.opacity=0.6}>‹</button>
            <button onClick={() => setIdx((idx+1)%exp.images.length)} style={{ position:'absolute',right:'-56px',top:'50%',transform:'translateY(-50%)',background:'none',border:'none',cursor:'pointer',color:'white',fontSize:'36px',opacity:0.6 }} onMouseEnter={e=>e.currentTarget.style.opacity=1} onMouseLeave={e=>e.currentTarget.style.opacity=0.6}>›</button>
          </>
        )}
        <div style={{ textAlign:'center',marginTop:'16px' }}>
          <span style={{ fontFamily:'var(--font-title)',fontStyle:'italic',fontSize:'1.1rem',color:'var(--gold2)' }}>{exp.title}</span>
        </div>
        {exp.images.length > 1 && (
          <div style={{ display:'flex',justifyContent:'center',gap:'6px',marginTop:'12px' }}>
            {exp.images.map((_,i) => <button key={i} onClick={()=>setIdx(i)} style={{ width:i===idx?'20px':'5px',height:'1px',background:i===idx?'var(--gold2)':'rgba(255,255,255,0.3)',border:'none',cursor:'pointer',transition:'all 0.3s',padding:0 }} />)}
          </div>
        )}
      </div>
      <button onClick={onClose} style={{ position:'absolute',top:'20px',right:'28px',background:'none',border:'none',cursor:'pointer',color:'white',fontSize:'24px',opacity:0.6 }} onMouseEnter={e=>e.currentTarget.style.opacity=1} onMouseLeave={e=>e.currentTarget.style.opacity=0.6}>✕</button>
    </div>
  );
}

export default function Experiences() {
  const [open, setOpen] = useState(null);

  return (
    <section id="experiences" style={{ background: '#ffffff', padding: '100px 0' }}>
      <div style={{ maxWidth: '1160px', margin: '0 auto', padding: '0 48px' }}>
        <div className="reveal" style={{ textAlign: 'center', marginBottom: '60px' }}>
          <span className="section-label">Explore our urban retreat</span>
          <h2 className="section-title">Non-ordinary Experiences</h2>
          <div className="gold-line center" />
        </div>

        {/* Vertical list: image left, text right */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
          {content.experiences.map((exp, i) => (
            <div key={i} className="reveal" style={{ display:'grid',gridTemplateColumns:'1fr 1fr',cursor:'pointer',border:'1px solid #ece8e0' }}
              onClick={() => setOpen(i)}>
              {/* Image */}
              <div style={{ position:'relative',overflow:'hidden',height:'320px' }}>
                <img src={`${pub}/${exp.images[0]}`} alt={exp.title} style={{ width:'100%',height:'100%',objectFit:'cover',transition:'transform 0.5s ease' }}
                  onMouseEnter={e=>e.target.style.transform='scale(1.04)'} onMouseLeave={e=>e.target.style.transform='scale(1)'}
                />
              </div>
              {/* Text */}
              <div style={{ padding:'48px 48px',display:'flex',flexDirection:'column',justifyContent:'center',background: i%2===0?'#ffffff':'var(--offwhite)' }}>
                <span style={{ fontFamily:'var(--font-body)',fontSize:'10px',letterSpacing:'0.28em',textTransform:'uppercase',color:'var(--gold)',display:'block',marginBottom:'12px' }}>{exp.label}</span>
                <h3 style={{ fontFamily:'var(--font-title)',fontSize:'1.6rem',color:'var(--text)',marginBottom:'16px' }}>{exp.title}</h3>
                <div style={{ width:'32px',height:'1px',background:'var(--gold)',marginBottom:'16px' }} />
                <p style={{ fontFamily:'var(--font-body)',fontSize:'13px',lineHeight:1.85,color:'var(--text2)',marginBottom:'24px' }}>{exp.text}</p>
                <span style={{ fontFamily:'var(--font-body)',fontSize:'11px',letterSpacing:'0.15em',textTransform:'uppercase',color:'var(--gold)' }}>
                  {exp.images.length > 1 ? `View gallery (${exp.images.length}) →` : 'View →'}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {open !== null && <Gallery exp={content.experiences[open]} onClose={() => setOpen(null)} />}
    </section>
  );
}
